/* lm-lightbox — shared fullscreen viewer reused by lookbook, gallery, and PDP.
   Triggers: any element with [data-lm-lightbox="<group>"] and data-full (+ optional data-srcset,
   data-alt). Clicking opens the viewer for that group at the clicked index. The <lm-lightbox>
   element is created on demand, so components only need triggers + this script + lm-lightbox.css.
   Idempotent: safe to include from multiple sections. */
(() => {
  if (window.__lmLightbox) return;
  window.__lmLightbox = true;

class LmLightbox extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <div class="lm-lightbox__backdrop" data-close></div>
      <button class="lm-lightbox__close" type="button" data-close aria-label="Close">&#8249;&nbsp;Close</button>
      <div class="lm-lightbox__index" aria-live="polite"><span class="lm-lightbox__i">1</span><span class="lm-lightbox__n">1</span></div>
      <img class="lm-lightbox__img" alt="" decoding="async">
      <button class="lm-lightbox__nav lm-lightbox__nav--prev" type="button" data-prev aria-label="Previous">&#8249;&nbsp;Previous</button>
      <button class="lm-lightbox__nav lm-lightbox__nav--next" type="button" data-next aria-label="Next">Next&nbsp;&#8250;</button>`;
    this.img = this.querySelector('.lm-lightbox__img');
    this.iEl = this.querySelector('.lm-lightbox__i');
    this.nEl = this.querySelector('.lm-lightbox__n');
    this.items = [];
    this.i = 0;

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]')) this.close();
      else if (e.target.closest('[data-prev]')) this.go(-1);
      else if (e.target.closest('[data-next]')) this.go(1);
    });
    this._onKey = (e) => {
      if (!this.hasAttribute('open')) return;
      if (e.key === 'Escape') this.close();
      else if (e.key === 'ArrowLeft') this.go(-1);
      else if (e.key === 'ArrowRight') this.go(1);
    };
    document.addEventListener('keydown', this._onKey);

    let startX = null;
    this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) this.go(dx < 0 ? 1 : -1);
      startX = null;
    });
  }

  disconnectedCallback() { document.removeEventListener('keydown', this._onKey); }

  open(items, index) {
    this.items = items || [];
    this.i = index || 0;
    this.render();
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    this.querySelector('[data-close]').focus();
  }

  close() {
    this.removeAttribute('open');
    document.body.style.overflow = '';
    this.img.removeAttribute('src');
    this.img.removeAttribute('srcset');
  }

  go(dir) {
    if (this.items.length < 2) return;
    this.i = (this.i + dir + this.items.length) % this.items.length;
    this.render();
  }

  render() {
    const it = this.items[this.i];
    if (!it) return;
    if (it.srcset) this.img.srcset = it.srcset; else this.img.removeAttribute('srcset');
    this.img.src = it.full;
    this.img.alt = it.alt || '';
    this.iEl.textContent = this.i + 1;
    this.nEl.textContent = this.items.length;
    const multi = this.items.length > 1;
    this.querySelector('[data-prev]').hidden = !multi;
    this.querySelector('[data-next]').hidden = !multi;
  }
}
customElements.define('lm-lightbox', LmLightbox);

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-lm-lightbox]');
  if (!trigger || !trigger.dataset.full) return;
  e.preventDefault();
  const group = trigger.getAttribute('data-lm-lightbox');
  const triggers = [...document.querySelectorAll(`[data-lm-lightbox="${CSS.escape(group)}"]`)];
  const items = triggers.map((el) => ({ full: el.dataset.full, srcset: el.dataset.srcset, alt: el.dataset.alt }));
  let box = document.querySelector('lm-lightbox');
  if (!box) {
    box = document.createElement('lm-lightbox');
    document.body.appendChild(box);
  }
  box.open(items, triggers.indexOf(trigger));
});
})();
